/**
 * Mega-menu photographs wait until the menu is used.
 *
 * Horizon's header-menu.js takes loading="lazy" off every menu image once the page has loaded,
 * so the menus open with their pictures ready. For the BTF cards (blocks/btf-mega-card.liquid
 * and the promo card) that meant a dozen photographs on every page, phones included, where the
 * desktop menu never opens. snippets/btf-image.liquid renders them with `deferred`, their
 * address in data-btf-src behind a blank placeholder, and this puts it back the first time
 * someone points at, touches or tabs into the menu: the small WebPs are in well before a panel
 * finishes opening.
 */
const load = () => {
  document.querySelectorAll('img[data-btf-src]').forEach((img) => {
    if (img.dataset.btfSrcset) img.srcset = img.dataset.btfSrcset;
    img.src = img.dataset.btfSrc;
    img.removeAttribute('data-btf-src');
    img.removeAttribute('data-btf-srcset');
  });
};

// The theme editor shows the cards as they are edited, so they load at once there
if (window.Shopify && window.Shopify.designMode) {
  load();
  document.addEventListener('shopify:section:load', load);
} else {
  document.querySelectorAll('header-menu').forEach((menu) => {
    ['pointerover', 'focusin', 'touchstart'].forEach((type) =>
      menu.addEventListener(type, load, { once: true, passive: true })
    );
  });
}
